import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class EmploymentRollingOffActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/RollingOff/RollingOffBrowser")
	}

	render() {
		return (
			<Activity 
				name="EmploymentRollingOff"
				RenderedComponent={this.RenderedComponent}
				context="EmploymentRollingOff"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(EmploymentRollingOffActivity)
